import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';

import { LayoutComponent } from './layout.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { LocaleDataSwitcherComponent } from './locale-data-switcher/locale-data-switcher.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule
  ],
  exports: [
    LayoutComponent
  ],
  declarations: [
    LayoutComponent,
    MainHeaderComponent,
    MainMenuComponent,
    LocaleDataSwitcherComponent
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/layout/layout.module.ts